import React, { useEffect, useState } from 'react'
import axios from 'axios'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Button, Label } from 'reactstrap'
import { ToggleButton } from 'primereact/togglebutton'

import ReactSelect from '../../common/CustomReactSelectComponent'
import DatePicker from '../../common/ReactDatePicker/ReactDatePicker'
import CustomTextarea from '../../common/CustomTextarea'
import Loader from '../Loader/BasicLoader'
import { setModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import { getDivisionsForCustomSelect } from '../Divisions/redux/DivisionActions'
import { IS_EXECUTIVE } from '../../constants/permissions'
import { markContractLost, setLoading } from './redux/contractLostActions'
import { clearAllErrors } from '../../actions/errorsActions'

const MarkContractLostModal = () => {
  const dispatch = useDispatch()
  const contact = useSelector((state) => state.contacts.contact)
  const divisions = useSelector((state) => state.divisions.divisionForSelect)
  const user = useSelector((state) => state.auth.user)
  const errors = useSelector((state) => state.errors)
  const isLoading = useSelector((state) => state.ContractLost.isLoading)
  const [data, setData] = useState({
    dateToFollowUp: null,
    dateLost: moment().format('MM/DD/YYYY'),
    lostReason: null,
    notes: null,
    divisionId: user.permissions.includes(IS_EXECUTIVE) ? null : user.division_id,
  })
  const [options, setOptions] = useState({
    reasonLostOptions: [],
  })
  const [isCreateTask, setIsCreateTask] = useState(false)

  useEffect(() => {
    if (isCreateTask) {
      dispatch(
        setModal({
          id: 'task_modal',
          name: `Edit Task ${contact.name}`,
          props: {
            contactIdTask: contact.id,
          },
        })
      )
    }
  }, [isCreateTask])

  useEffect(() => {
    getOptions()
    dispatch(getDivisionsForCustomSelect())
    return () => dispatch(clearAllErrors())
  }, [])

  useEffect(() => {
    if (Object.keys(errors).length) {
      dispatch(setLoading())
    }
  }, [errors])

  const getOptions = async () => {
    const responseOptions = await axios.get(`/support-tables`, {
      params: { tableFilter: { support_type_id: 27 } },
    })
    const reasonLostOptions = []
    responseOptions.data.data.forEach((option) => {
      reasonLostOptions.push({
        id: option.id,
        name: option.name,
      })
    })
    setOptions({ ...options, reasonLostOptions })
  }

  const handleChangeSelect = (value, e) => {
    setData({
      ...data,
      [e.name]: value ? value.id : null,
    })
  }

  const handleChangeDate = (date, name) => {
    const value = date ? moment(date).format('MM/DD/YYYY') : ''
    setData({ ...data, [name]: value })
  }

  const onChangeNote = (e) => {
    setData({ ...data, ['notes']: e.target.value })
  }

  const onSave = async () => {
    dispatch(setLoading())
    const dataContractLost = {
      ...data,
      dateToFollowUp: data.dateToFollowUp ? moment(data.dateToFollowUp) : null,
      dateLost: data.dateLost ? moment(data.dateLost) : null,
      contactId: contact.id,
      creationDateStatusChanges: new Date(),
    }
    await dispatch(markContractLost(dataContractLost))
  }

  let loader = null
  if (isLoading) loader = <Loader />

  return (
    <>
      {loader}
      <Row>
        <Col md='6'>
          <ReactSelect
            options={options.reasonLostOptions}
            defaultValue={data.lostReason}
            onChange={handleChangeSelect}
            name='lostReason'
            label='Contract Lost Reason'
            placeholder='Please Select...'
            isClearable={true}
            invalid={!!errors.lostReason}
            errorMess={errors.lostReason ? errors.lostReason : ''}
          />
        </Col>
        <Col md='6'>
          <ReactSelect
            options={divisions}
            defaultValue={data.divisionId}
            onChange={handleChangeSelect}
            name='divisionId'
            label='Division'
            placeholder='Please Select...'
            isClearable={true}
            disabled={!user.permissions.includes(IS_EXECUTIVE)}
            invalid={!!errors.divisionId}
            errorMess={errors.divisionId ? errors.divisionId : ''}
          />
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col md='6'>
          <DatePicker
            selected={data.dateLost ? new Date(data.dateLost) : ''}
            errorMess={errors.dateLost ? errors.dateLost : ''}
            onChange={(date) => handleChangeDate(date, 'dateLost')}
            label='Date Contract Lost'
            showTimeSelect={false}
            showTimeInput={false}
            isClearable
            placeholder='mm/dd/yyyy'
            dateFormat='MM/dd/yyyy'
          />
        </Col>
        <Col md='6'>
          <DatePicker
            selected={data.dateToFollowUp ? new Date(data.dateToFollowUp) : ''}
            // errorMess={errors.dueDate ? errors.dueDate : ''}
            onChange={(date) => handleChangeDate(date, 'dateToFollowUp')}
            label='Date To Follow Up'
            showTimeSelect={false}
            showTimeInput={false}
            isClearable
            placeholder='mm/dd/yyyy'
            dateFormat='MM/dd/yyyy'
          />
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          <div className='text-start'>
            <Label>Create Task</Label>
            <div>
              <ToggleButton checked={isCreateTask} onChange={() => setIsCreateTask(!isCreateTask)} />
            </div>
          </div>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          <CustomTextarea label='Notes' rows={3} onChange={onChangeNote} value={data.notes} placeholder='Notes...' />
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex justify-content-end'>
          <Button className='gold-color-button btn btn-sm' onClick={onSave} disabled={isLoading}>
            Save
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default MarkContractLostModal
